import React, { useEffect, useState } from "react";
import axios from "axios";
import { isAutheticated } from "../auth/authhelper";
import { API } from "../../API";
import { useHistory } from "react-router-dom";
import { Link } from "react-router-dom";

export default function Billing() {
    const history = useHistory();
    const { token } = isAutheticated();

    const [payments, setPayments] = useState([]);
    const [filters, setFilters] = useState({ month: "" });

    const [currentPage, setCurrentPage] = useState(1);
    const rowsPerPage = 15;   // Backend limit match
    const [totalPages, setTotalPages] = useState(1);
    const [loading, setLoading] = useState(false);

    // 👉 Navigate
    const handleViewInvoice = (payment) => {
        history.push(`/invoice/${payment._id}`);
    };

    // 👉 Fetch invoices from backend
    const fetchInvoices = async (page = 1) => {
        try {
            setLoading(true);

            const res = await axios.get(`${API}/api/invoices/registration_Invoices`, {
                params: {
                    page,
                    limit: rowsPerPage,
                    ...filters,
                    id: "all",
                    invoiceFor: "all",
                },
                headers: { Authorization: `Bearer ${token}` },
            });

            if (res.data.success) {
                setPayments(res.data.invoices || []);
                setTotalPages(res.data.pages || 1);
            }
        } catch (err) {
            console.error("Error fetching invoices:", err);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchInvoices(currentPage);
    }, [currentPage, filters]);

    const handlePageChange = (page) => setCurrentPage(page);

    const handleFilterChange = (e) => {
        setFilters({ ...filters, [e.target.name]: e.target.value });
        setCurrentPage(1);
    };

    return (
        <div className="main-content">
            <div className="page-content">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-12">
                            <div className="page-title-box d-flex align-items-center justify-content-between">
                                <h4 className="mb-0">Billing - Registration Fees</h4>

                                <div className="page-title-right">
                                    <ol className="breadcrumb m-0">
                                        <li className="breadcrumb-item">
                                            <Link to="/dashboard">SoComOTT</Link>
                                        </li>
                                        <li className="breadcrumb-item">
                                            Billing - Registration Fees
                                        </li>
                                    </ol>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='col-lg-12'>
                        <div className='card'>
                            <div className='card-body'>
                                <div className="container">
                                    {/* <h2 className="mb-4">Registration Fees</h2> */}

                                    {/* TABLE */}
                                    {/* <table className="table table-bordered table-striped shadow-sm">
                            <thead className="thead-dark"> */}
                                    <table className='table table-centered table-nowrap mb-0'>
                                        <thead className='thead-light'>
                                            <tr className="text-center">
                                                <th>#</th>
                                                <th>Channel</th>
                                                <th>Type</th>
                                                <th>Invoice No.</th>
                                                <th>Date</th>
                                                <th>Amount</th>
                                                <th>Status</th>
                                                <th>Action</th>
                                            </tr>
                                        </thead>

                                        <tbody>
                                            {loading ? (
                                                <tr>
                                                    <td colSpan="8" className="text-center py-4">
                                                        {/* <div className="spinner-border text-primary"></div> */}
                                                        <p className="mt-2">Loading invoices...</p>
                                                    </td>
                                                </tr>
                                            ) : payments.length > 0 ? (
                                                payments.map((p, idx) => (
                                                    <tr key={p._id}>
                                                        <td className="text-center">
                                                            {(currentPage - 1) * rowsPerPage + idx + 1}
                                                        </td>

                                                        <td className="text-center">
                                                            {p.invoiceFor === "channel"
                                                                ? p?.subchannelName
                                                                : p?.network_channelName}
                                                        </td>

                                                        <td className="text-center">
                                                            {p.invoiceFor === "channel" ? "Channel" : "Network"}
                                                        </td>

                                                        <td className="text-center">{p.invoiceNumber}</td>

                                                        <td className="text-center">
                                                            {new Date(p.createdAt).toLocaleDateString("en-US", {
                                                                day: "2-digit",
                                                                month: "short",
                                                                year: "numeric",
                                                            })}
                                                        </td>

                                                        <td className="text-center">${p.amount}</td>

                                                        <td className="text-center">
                                                            <span className={`badge ${p.status === "paid"
                                                                ? "bg-success"
                                                                : "bg-warning"
                                                                }`}>{p.status}</span>
                                                        </td>

                                                        <td className="text-center">
                                                            <button
                                                                className="btn btn-primary btn-sm"
                                                                onClick={() => handleViewInvoice(p)}
                                                            >
                                                                View Invoice
                                                            </button>
                                                        </td>
                                                    </tr>
                                                ))
                                            ) : (
                                                <tr>
                                                    <td colSpan="8" className="text-center py-3">
                                                        No invoices found.
                                                    </td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>

                                    {/* PAGINATION */}
                                    {totalPages > 1 && !loading && (
                                        <nav>
                                            <ul className="pagination justify-content-center">
                                                {[...Array(totalPages)].map((_, i) => (
                                                    <li
                                                        key={i}
                                                        className={`page-item ${currentPage === i + 1 ? "active" : ""}`}
                                                    >
                                                        <button
                                                            className="page-link"
                                                            onClick={() => handlePageChange(i + 1)}
                                                        >
                                                            {i + 1}
                                                        </button>
                                                    </li>
                                                ))}
                                            </ul>
                                        </nav>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
